var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Gs=require("ttag");module.exports=$CLJS.Gs;